/* FJC 2026-10-15: polish for the Klaviyo sign-up form (klaviyo-form-Y3gQdc) on the Black
   Friday Exclusive landing page and in the modal (sections/fjc-bf-signup-landing.liquid,
   sections/fjc-bf-announcement.liquid). Runs on every .fjc-bf-landing__form--styled wrapper
   once Klaviyo has injected the form, and again whenever Klaviyo re-renders (step change):
   1. "Privacy Policy" in the form's text becomes a link to the store's privacy policy
      (Chummy's recording: bold, underlined on hover). Klaviyo's text has it as plain words;
      the link styling itself is in assets/fjc-bf-signup-landing.css.
   2. Consecutive left-aligned body paragraphs in one rich-text block are joined into one
      paragraph (the design's single paragraph; Klaviyo has the two sentences as two <p>).
      Centred paragraphs (headings) and blank spacer paragraphs are left alone.
   3. On Klaviyo's submit event for this form, remember the sign-up in this browser
      (localStorage fjcBfSignedUp) and hide the announcement strip at once; the strip's own
      inline script keeps it hidden on later page loads. Per browser only: the same person on
      another device sees the strip again.
   4. On the landing page the success step's CONTINUE SHOPPING button goes to the URL in the
      section's data-fjc-bf-continue-url (home by default). Its Klaviyo action is "Close form"
      (Marija, 19 Oct), which is what the site-wide modal needs (assets/fjc-bf-announcement.js
      closes the modal on it); on the page itself it would only blank the embed, so the click is
      taken here in the capture phase and the page navigates instead. Not applied inside the modal.
   Both polish steps are no-ops if Marija changes the form to match the design herself. */
(function () {
  'use strict';

  var PRIVACY_URL = '/policies/privacy-policy';
  var PRIVACY_TEXT = 'Privacy Policy';
  var FLAG = 'data-fjc-bf-polished';
  var CONTINUE_LABEL = /^\s*continue\s+shopping\s*$/i;

  function isBlank(el) {
    return !el.textContent.replace(/[\s​ ]/g, '').length;
  }

  function isLeftParagraph(el) {
    if (!el || el.tagName !== 'P' || isBlank(el)) return false;
    var align = (el.style && el.style.textAlign) || getComputedStyle(el).textAlign;
    return align === 'left' || align === 'start';
  }

  // 2. join runs of consecutive left-aligned, non-blank paragraphs
  function joinParagraphs(root) {
    var blocks = root.querySelectorAll('.klaviyo-form-richtext, [class*="richtext"]');
    Array.prototype.forEach.call(blocks, function (block) {
      var p = block.firstElementChild;
      while (p) {
        var next = p.nextElementSibling;
        if (isLeftParagraph(p) && isLeftParagraph(next)) {
          var last = p.lastChild;
          if (last && !/\s$/.test(last.textContent)) p.appendChild(document.createTextNode(' '));
          while (next.firstChild) p.appendChild(next.firstChild);
          next.parentNode.removeChild(next);
          continue; // p may now be followed by another left paragraph
        }
        p = next;
      }
    });
  }

  // 1. wrap "Privacy Policy" in a link when it is not one already
  function linkPrivacy(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (node.nodeValue.indexOf(PRIVACY_TEXT) === -1) return NodeFilter.FILTER_REJECT;
        if (node.parentElement && node.parentElement.closest('a')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var i = node.nodeValue.indexOf(PRIVACY_TEXT);
      var after = node.splitText(i);
      after.splitText(PRIVACY_TEXT.length);
      var a = document.createElement('a');
      a.href = PRIVACY_URL;
      a.target = '_blank';
      a.rel = 'noopener';
      a.className = 'fjc-bf-privacy-link';
      a.textContent = PRIVACY_TEXT;
      after.parentNode.replaceChild(a, after);
    });
  }

  function polish(wrapper) {
    var form = wrapper.querySelector('form');
    if (!form || form.getAttribute(FLAG)) return;
    form.setAttribute(FLAG, '1');
    joinParagraphs(form);
    linkPrivacy(form);
  }

  function init() {
    var wrappers = document.querySelectorAll('.fjc-bf-landing__form--styled');
    if (!wrappers.length) return;
    Array.prototype.forEach.call(wrappers, function (wrapper) {
      polish(wrapper);
      // Klaviyo injects the form later, and swaps its content on the success step
      new MutationObserver(function () { polish(wrapper); }).observe(wrapper, { childList: true, subtree: true });
    });
  }

  // 4. landing page: CONTINUE SHOPPING leaves the page (capture phase, before Klaviyo's own close)
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var button = target.closest('button, a');
    if (!button || !button.closest('[class*="klaviyo-form"]') || !CONTINUE_LABEL.test(button.textContent)) return;
    if (button.closest('[data-fjc-bf-modal]')) return; // the modal closes itself instead
    var panel = button.closest('[data-fjc-bf-continue-url]');
    var url = panel && panel.getAttribute('data-fjc-bf-continue-url');
    if (!url) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.assign(url);
  }, true);

  // 3. sign-up remembered per browser (Klaviyo's documented "klaviyoForms" event)
  window.addEventListener('klaviyoForms', function (e) {
    var d = e && e.detail;
    if (!d || d.type !== 'submit') return;
    var bar = document.querySelector('[data-fjc-bf-bar]');
    var wanted = bar ? bar.getAttribute('data-fjc-bf-form-id') : null;
    if (wanted && d.formId && d.formId !== wanted) return;
    try { localStorage.setItem('fjcBfSignedUp', '1'); } catch (err) { /* storage blocked */ }
    if (bar && bar.getAttribute('data-fjc-bf-hide-after-signup') === 'true') bar.hidden = true;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
